import { ClassOfService, PassengerType, TClassOfService, TPassengerType } from "@/shared/api/aviabooking";

export const AvailablePassengerTypes = [
    PassengerType.ADT,
    PassengerType.CNN,
    PassengerType.INF
]

export const PassengerTypeNames: Record<TPassengerType, { title: string, description: string }> = {
    "ADT": {
        title: "Взрослые",
        description: "12 лет и старше",
    },
    "CNN": {
        title: "Дети",
        description: "от 2 до 11 лет",
    },
    "INF": {
        title: "Младенцы",
        description: "Младше 2 лет, без места",
    },
}

export const AvailableClassOfService = [
    ClassOfService.All,
    ClassOfService.Business,
    ClassOfService.Economy,
    ClassOfService.PremiumEconomy,
    ClassOfService.First
]

export const ClassOfServiceNames: Record<TClassOfService, { title: string }> = {
    Economy: {
        title: "Эконом"
    },
    Business: {
        title: "Бизнесс класс"
    },
    First: {
        title: "Первый класс"
    },
    PremiumEconomy: {
        title: "Премиум эконом"
    },
    All: {
        title: "Все классы"
    }
}